import React, {useRef} from 'react';

import styles from './solutions-section.module.scss';
import {InputPill} from './input-pill';

interface SolutionsHeaderProps {
    selected: number;
    onSelect: (idx: number) => void;
    tagLabels: string[];
}

const SolutionsHeader: React.FC<SolutionsHeaderProps> = ({selected, onSelect, tagLabels}) => {
    const tagsContainerRef = useRef<HTMLDivElement>(null);

    const handleTabClick = (idx: number) => {
        onSelect(idx);

        // Scroll the clicked tab to center on mobile
        if (tagsContainerRef.current) {
            const container = tagsContainerRef.current;
            const tab = container.children[idx] as HTMLElement;
            if (tab) {
                const containerWidth = container.offsetWidth;
                const tabLeft = tab.offsetLeft;
                const tabWidth = tab.offsetWidth;
                const scrollLeft = tabLeft - containerWidth / 2 + tabWidth / 2;

                container.scrollTo({
                    left: scrollLeft,
                    behavior: 'smooth',
                });
            }
        }
    };

    return (
        <>
            <div className={styles.contentWrapper}>
                <div className={styles.tagsContainer} ref={tagsContainerRef}>
                    {tagLabels.map((label, idx) => (
                        <InputPill
                            key={label}
                            text={label}
                            className={`${styles.skillTag} ${selected === idx ? styles.selectedTag : ''}`}
                            onClick={() => handleTabClick(idx)}
                            aria-pressed={selected === idx}
                        />
                    ))}
                </div>
            </div>
        </>
    );
};

export {SolutionsHeader};
